import { C } from "./theme";
import { PENCIL } from "./EditButton";

// One item in a list card (listCard): its words and a pencil, tap it to change or delete it. Mindset, Gratitude,
// Habits, Temptations, Radar's Habits, Dreams and Fears, and the Dreamboard's Names. `chooseOnly` is a picker (the Goal
// page's habits): the row picks the item, so it has no pencil and its name is its words. `lead` goes before the words
// (a habit's ↑ or ↓), `pill` under them (a habit's frequency) and `note` is a line under them; `marks` ("building,
// daily") is read out with the name for what `lead` and `pill` show. `handle` is a ⠿ to drag the row, beside the row's
// button rather than inside it. `first` leaves off the line above.
export function ListRow({ text, first, editLabel, onEdit, chooseOnly = false, lead = null, pill = null, marks = "", note = null, handle = null }) {
  const name = chooseOnly ? [text, marks, note].filter(Boolean).join(". ") : `${editLabel}${marks ? `, ${marks}` : ""}: ${text}`;
  return (
    <div style={{ display: "flex", alignItems: "flex-start", borderTop: first ? "none" : `1px solid ${C.border}` }}>
    <button onClick={onEdit} aria-label={name}
      style={{ flex: 1, minWidth: 0, minHeight: 48, display: "flex", alignItems: "flex-start", gap: 10, padding: "12px 6px 12px 14px", background: "none", border: "none", cursor: "pointer", fontFamily: "inherit", textAlign: "left", color: C.text }}>
      {lead}
      <span style={{ flex: 1, minWidth: 0 }}>
        <span style={{ display: "block", fontSize: 16, fontWeight: 600, lineHeight: 1.45 }}>{text}</span>
        {pill && <span style={{ display: "inline-block", marginTop: 4, fontSize: 13, fontWeight: 500, color: C.textMid, background: C.surface2, borderRadius: 10, padding: "2px 8px" }}>{pill}</span>}
        {note && <span style={{ display: "block", marginTop: 4, fontSize: 14, lineHeight: 1.45, color: C.textMid, fontWeight: 400 }}>{note}</span>}
      </span>
      {!chooseOnly && <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={C.textMid} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ flexShrink: 0, margin: "3px 8px 0" }}>{PENCIL}</svg>}
    </button>
    {handle}
    </div>
  );
}

// The card a list of rows sits in.
export const listCard = () => ({ background: C.surface, border: `1px solid ${C.borderCard}`, borderRadius: C.r, overflow: "hidden", boxShadow: C.shadow });
